import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { routePrefix } from '../../config'
import moment from 'moment'
import { connect } from 'react-redux'
import * as actions from '../../containers/inventoryView/actions'
import { MONTHS } from '../../utils/constants';
import upArrow from '../../images/upArrow.svg';
import backArrow from '../../images/paginationBackArrow.svg'
import forwardArrow from '../../images/forwardArrow.svg'


class InPageCalendar extends Component {

  state = {
    monthNumber: 1,
    selectedDate: localStorage.getItem('selected-date') || moment().format("YYYY-MM-DD"),
  }

  onMonthPrevClick = () => {
    if (this.state.monthNumber === 1) return;
    else {
      this.setState({ monthNumber: this.state.monthNumber - 1 });
    }
  }

  onMonthNextClick = () => {
    if (this.state.monthNumber < 3) {
      this.setState({ monthNumber: this.state.monthNumber + 1 });
      return;
    }
  }

  getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var endDate = moment(stopDate);
    while (currentDate <= endDate) {
      dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
      currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  }

  getWeekIndex(date) {
    let weekIndex;
    const weekDays = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"];
    const currentWeek = moment(date).format('dd');
    weekDays.forEach((item, index) => {
      if (item === currentWeek) {
        weekIndex = index
      }
    });
    return weekIndex;
  }

  isDisabledTile(date, disabledDays) {
    return disabledDays.includes(date)
  }

  renderNameOfDays() {
    const nameOfDays = ['M', 'T', 'W', 'T', 'F', 'S', 'S'];
    return (
      <>
        {nameOfDays.map((day, i) => (
          <span key={i} className="inPageDay">{day}</span>
        ))}
      </>
    );
  }

  onPageRedirection = (e, date) => {
    e.stopPropagation();
    localStorage.setItem('selected-date', date);
    this.props.fetchInventoryRouteLevelView(date);
    this.props.renderInPageCalendar();
  }

  isSelectedDate = (date) => {
    return date === this.state.selectedDate
  }

  renderInventorycalendar(allDates, isDataPresentDates) {
    let finalResult;
    const firstDay = allDates[0];
    const dateBeforeFirstDay = moment(firstDay).subtract(1, 'days');
    const weekIndex = this.getWeekIndex(firstDay);
    const numberOfDisabledDays = weekIndex;
    const lastDisabledDate = moment(firstDay).subtract(numberOfDisabledDays, 'days');
    const lastDisabledDateFormatted = moment(lastDisabledDate).format('YYYY-MM-DD');
    const disabledDays = this.getDates(lastDisabledDateFormatted, dateBeforeFirstDay);
    const datesToDisplay = numberOfDisabledDays === 0 ? allDates : disabledDays.concat(allDates);
    if (isDataPresentDates) {
      finalResult = datesToDisplay.map((date, index) => {
        return (
            <div key={index}>
              <Link
                to={routePrefix + '/inventory-view/daylevel'}
                onClick={(e) => { this.onPageRedirection(e, date) }}
              >
                <span className={(this.isSelectedDate(date) && !this.isDisabledTile(date, disabledDays)) ? 'inPageToday' : 'inPageDate'}>
                  {this.isDisabledTile(date, disabledDays) ? null : moment(date).format("DD")}
                </span>
              </Link>
            </div>
        );
      });
    }
    return finalResult;
  }

  getMonthDates(month, allDates) {
    const monthDates = [];
    let monthToSearch;
    if (month + 1 < 10) {
      monthToSearch = `0${month + 1}`
    }
    else {
      monthToSearch = (month + 1).toString()
    }
    allDates.map((item) => {
      if (item.includes(`-${monthToSearch}-`)) {
        monthDates.push(item)
      }
    })
    return monthDates
  }

  getMonthName(dates) {
    const firstDay = dates && dates[0];
    return (moment(firstDay).format("MMMM YYYY"))
  }
  renderCalendarDates(monthOneDates, monthTwoDates, monthThreeDates, isDataPresentDates) {
    let dates;
    if (this.state.monthNumber === 1) {
      dates = monthOneDates;
    }
    else if (this.state.monthNumber === 2) {
      dates = monthTwoDates;
    }

    else if (this.state.monthNumber === 3) {
      dates = monthThreeDates;
    }
    if (dates) {
      return (
        <div>
        <div className='calendarHeader'>
              <img className="backIcon" src={backArrow} alt="icon" onClick={this.onMonthPrevClick} />
              <div className='inPageMonthName'>{this.getMonthName(dates)}</div>
              <img className="backIcon" src={forwardArrow} alt="icon" onClick={this.onMonthNextClick} />
            </div>
            <div className='inPageWeekDays'>
              {this.renderNameOfDays()}
            </div>
        <div className='inPageTable'>
          {this.renderInventorycalendar(dates, isDataPresentDates)}
        </div>
        </div>)
    }

  }


  render() {
    const responseDateArray = localStorage && JSON.parse(localStorage.getItem('inventory-calendar'));
    const isDataPresentDates = responseDateArray && responseDateArray.map(a => a.date);
    const monthOneDates = localStorage && JSON.parse(localStorage.getItem('current-month-dates'));
    const monthTwoDates = localStorage && JSON.parse(localStorage.getItem('next-month-dates'));
    const monthThreeDates = localStorage && JSON.parse(localStorage.getItem('after-month-dates'));
    return (
      responseDateArray ?
        <>
          <span><img className="upArrowDates" src={upArrow} alt="icon" /></span>
          <div className='calendar'>
            {this.renderCalendarDates(monthOneDates, monthTwoDates, monthThreeDates, isDataPresentDates)}
          </div>
        </>
        :
        null

    )
  }
}

const mapStateToProps = store => ({
  inventoryCalendarViewData: store.inventoryViewReducer.inventoryCalendarViewData,
})

const mapDispatchToProps = dispatch => ({
  fetchInventoryCalendarView: (payload, query) => dispatch(actions.fetchInventoryCalendarView(payload, query)),
  fetchInventoryRouteLevelView: (date, isViaRoutes) => dispatch(actions.fetchInventoryRouteLevelView(date, isViaRoutes)),
})

export default connect(mapStateToProps, mapDispatchToProps)(InPageCalendar)
